import { IntlShape } from "react-intl";

export function getDeliveryServiceLevelOptions(intl: IntlShape) {
  return [
    {
      value: "1",
      label: intl.formatMessage({
        id: "new-request.schedule.selectServiceLevel1Day",
        defaultMessage: "1 day",
      }),
    },
    {
      value: "3",
      label: intl.formatMessage({
        id: "new-request.schedule.selectServiceLevel3Day",
        defaultMessage: "3 day",
      }),
    },
    {
      value: "5",
      label: intl.formatMessage({
        id: "new-request.schedule.selectServiceLevel5Day",
        defaultMessage: "5 day",
      }),
    },
    {
      value: "7",
      label: intl.formatMessage({
        id: "new-request.schedule.selectServiceLevel7Day",
        defaultMessage: "7 day",
      }),
    },
    {
      value: "NA",
      label: intl.formatMessage({
        id: "new-request.schedule.selectServiceLevelNA",
        defaultMessage: "Not Applicable - E.g. for Ocean freight",
      }),
    },
  ];
}
